import { render, staticRenderFns } from "./OnBoardingContent.vue?vue&type=template&id=3d72a3ab"
import script from "./OnBoardingContent.vue?vue&type=script&lang=js"
export * from "./OnBoardingContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports